<form [formGroup]="searchForm">
  <div [ngStyle]="{ width: style }">
    <mat-form-field>
      <mat-label>{{ title || ("franchise" | translate) }}</mat-label
      ><input
        *ngIf="required; else optionalField"
        type="text"
        matInput
        required
        formControlName="franchise"
        [matAutocomplete]="auto"
      />
      <ng-template #optionalField>
        <input
          type="text"
          matInput
          formControlName="franchise"
          [matAutocomplete]="auto"
        />
      </ng-template>

      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let f of franchises$ | async"
          (onSelectionChange)="handleSelect($event, f)"
          [value]="f.name"
          class="autocomplete"
        >
          {{ f.name }}
        </mat-option>
      </mat-autocomplete>

      <mat-error
        *ngIf="searchForm.controls.franchise.touched && searchForm.invalid"
      >
        {{ requiredText || "required-franchise" | translate }}
      </mat-error>
    </mat-form-field>
  </div>
</form>
